import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Contact from './Components/Contact';
import Header from './Components/Header';
import Footer from './Components/Footer';
import FloatingButtons from './Components/FloatingButtons';
import CallForm from './Components/CallForm';


import Gallery from './Components/Gallery'; // Import the new Gallery component
import About from './Components/About';
import FAQ from './Components/FAQSection';
import PrivacyPolicy from './Components/PrivacyPolicy';
import TermsAndConditions from './Components/TermsAndConditions';
import SaffronHabitat from './Components/SaffronHabitat';
import Blog from "./Components/Blog";
import BlogPost from "./Components/BlogPost";
import ScrollToTop from "./Components/ScrollToTop"; // <-- IMPORT
import PageTitle from "./Components/PageTitle"; // <-- IMPORT
import PropertyPage from "./Components/PropertyPage"; // <-- IMPORT
import PropertyDetails from './Components/PropertyDetails';


function App() {
  return (
    <Router>
      <PageTitle />
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
              <Route path="/" element={<CallForm />} />
          {/* <Route path="/" element={<Home />} /> */}
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/TermsAndConditions" element={<TermsAndConditions />} />
          <Route path="/SaffronHabitat" element={<SaffronHabitat />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/properties" element={<PropertyPage />} />
          <Route path="/property/:id" element={<PropertyDetails />} />
        </Routes>
        <FloatingButtons />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
